import type { QuestionnaireItem, QuestionnaireResponseItem } from '@medplum/fhirtypes';

/** Stable key for a questionnaire text answer (must match collectTextAnswerSnapshots). */
export function buildQuestionnaireTextFieldKey(
  context: QuestionnaireResponseItem[],
  linkId: string | undefined,
  answerIndex: number,
): string {
  const parts = [
    ...context.map((c) => c.linkId).filter(Boolean),
    linkId,
    String(answerIndex),
  ].filter(Boolean) as string[];
  return parts.join('/');
}

export function isQuestionnaireTextInputItem(item: QuestionnaireItem): boolean {
  return item.type === 'text' || item.type === 'string';
}
